import { type GetStaticPropsContext, type NextPageWithLayout } from 'next'
import React, { type ReactNode, useEffect } from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { SHOWROOM_PAGE_SLUG } from 'constants/common'
import { klaviyoTrackViewedShowroom } from 'utils/klaviyo'
import {
  prepareGetStaticPropsForShowroomPage,
  ShowroomPageView,
  useCmsShowroomPageBySlug,
} from '../CmsPage/ShowroomPage'

export const Showroom: NextPageWithLayout = () => {
  const { pageBySlug, isLoading, widgets } = useCmsShowroomPageBySlug({
    slug: SHOWROOM_PAGE_SLUG,
    isShowroomIndexPage: true,
  })

  useEffect(() => klaviyoTrackViewedShowroom(), [])

  return (
    <ShowroomPageView
      slug={SHOWROOM_PAGE_SLUG}
      data={pageBySlug}
      isLoading={isLoading}
      widgets={widgets}
      fallbackMetaTitle="Shop Modern & Vintage Home Decor - The Expert Showroom"
      fallbackDescription="Shop vintage and contemporary furniture, decor, lighting, rugs, and more handpicked by the world's best interior designers. Discover 70+ Expert-loved brands."
    />
  )
}

export function getStaticProps(context: GetStaticPropsContext) {
  return prepareGetStaticPropsForShowroomPage(context, {
    slug: SHOWROOM_PAGE_SLUG,
  })
}

const PageLayout = (page: ReactNode) =>
  getPublicLayout(page, { isFullWidth: true, isWithBreadcrumbs: true })

Showroom.getLayout = PageLayout
